import { Typography } from '@mui/material';
import { Box, Container } from '@mui/system';
import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../providers/AuthProvider';
import { CTA } from '../Common/CTA';

const PrizeContainer = styled.section`
  background-color: var(--primary);
  padding: 2.5rem 0;

  img {
    max-width: 800px;
    margin: 0 auto;
  }
`;

const YellowText = styled.span`
  color: var(--secondary);
  font-family: 'GothamBold' !important;
`;
const PinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &>.MuiTypography-root {
    background-color: var(--primary-dark);
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    line-height: 1.2;
  }
`;

export const Prize = () => {
  const { REGISTER_EXPIRES } = useAuth();

  return (
    <PrizeContainer>
      <Container>
        <Typography
          variant='h5'
          align='center'
          className='white--text'
          gutterBottom
        >
          A cada R$100 em compras,
        </Typography>

        <Typography
          variant='h3'
          align='center'
          className='white--text upper bold-text min-line'
          gutterBottom
        >
          Ganhe 1 <YellowText>slime</YellowText> +<br/>
          <span className='bold-text subtitle'>
            1 <YellowText>bilhete surpresa</YellowText>
          </span>
        </Typography>

        <Typography
          variant='h5'
          align='center'
          className='white--text'
          gutterBottom
        >
          e concorra a
        </Typography>

        <PinkContainer>
          <Typography
            variant='h3'
            className='white--text bold-text'
            align='center'
          >
            + <YellowText className='upper subtitle'>de 3 mil prêmios</YellowText>
            <Typography variant='h5' component='span'> divertidos</Typography>
          </Typography>
        </PinkContainer>
        <Box align='center' my={4}>
          <img src='./images/cards.png' alt='Cartão: Raspou, achou, brincou!' className='img-responsive' />
        </Box>

        <PinkContainer>
          <Typography
            variant='h5'
            className='white--text'
            align='center'
          >
            e você ainda pode <YellowText className='upper subtitle'>Ganhar 10 Nintendo Switch</YellowText><br />
            se cadastrando <span className='bold-text'>aqui neste site</span>!
          </Typography>
        </PinkContainer>
        <Box mt={4} align='center'>
          { REGISTER_EXPIRES > (new Date().getTime()) ? <CTA drawer='register' /> : <CTA drawer='login'>Entrar</CTA> }
        </Box>
      </Container>
    </PrizeContainer>
  )
}
